/** Normalizes `query-string` values to a single string (React 19–friendly for URL state). */
export function firstQueryValue(value: string | (string | null)[] | null | undefined): string {
    if (value == null) return '';
    if (Array.isArray(value)) return value[0] ?? '';
    return value;
}
